import '../app/DemandedJobs.scss';
import '../app/HireTalent.scss';
import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Categories from '../app/Categories';
import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import toList, { redirectPage } from '../utils/ComponentUtil';
import { Typography } from '@mui/material';
import Header from '../utils/Header';
import Footer from '../../components/app/Footer';
import CustomPagination from '../utils/CustomPagination';
import history from '../../history';
import CustomSearchBar from '../utils/CustomSearchBar';
import Filter from "../../images/talent/filters.png";
import CustomRadioInput from '../utils/CustomRadioInput';
import { ArrowBack } from '@mui/icons-material';
import FindProjectFilter from '../Filters/FindProjectFilter';
import FindProjectAPI from '../Apis/FindProjectAPI';


function FindProjectsPage() {
    const { type, subType } = useParams();
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(1);
    const [searchInput, setSearchInput] = useState('');
    const [projects, setProjects] = useState([]);
    const [filters, setFilters] = useState({ experiences: ['1-2 Years', '5-10 Years'] });
    const [openFilter, setOpenFilter] = useState(false);
    const projectPage = FindProjectAPI.projectPages[type];


    useEffect(() => {
        setPage(searchParams.get("page") ? parseInt(searchParams.get("page")) : 1);
        setSearchInput(searchParams.get("searchInput") ? searchParams.get("searchInput") : '');
    }, [searchParams]);

    useEffect(() => {
        console.log(filters);
        const projects = FindProjectAPI.fetchProjectsByType(type, subType, page, searchInput);
        setProjects(projects);
    }, [type, subType, page, searchInput, filters]);

    const setCurrentPage = (page) => {
        setPage(page);
        history.push(window.location.pathname + "?" + (page ? 'page=' + page + '' : ''));
    }

    const goBack = () => {
        history.back();
    }

    const breadcrumbs = [toList([{ to: "/", child: "Home" }, { to: "/find-project", child: "Find a Project" }], Link)
        , <Typography className="job-page-name">{projectPage?.name}</Typography>];
    const landingPage = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography className="job-page-name">Find a Project</Typography>];

    return (<div>
        <Navbar selected='Find Work'></Navbar>
        <div className='talent-group-wrp wrapper'>
            {
                searchInput ? <><div className='search-back-wrp' onClick={goBack}>
                    <ArrowBack />
                    <span>Search Results</span>
                </div></> :
                    <>
                        <CustomBreadcrumbs breadcrumbs={type ? breadcrumbs : landingPage} />
                        <Header title={projectPage?.name}></Header>
                    </>
            }
            <CustomSearchBar to={projectPage?.to} placeholder='Search by names, locations, skills, jobs' />
        </div>
        <div className='searchable-wrp wrapper'>
            <FindProjectFilter open={openFilter} showHideSetter={setOpenFilter} onChange={(e, d) => setFilters(d)} />
            <div className='search-results'>
                <div className='filter-icon' onClick={() => setOpenFilter(true)}>Filter<img src={Filter} alt='filter' title='Filter Projects' /></div>
                <div className='search-results-wrp'>
                    <h3>Categories</h3>
                    {<CustomRadioInput value={type ? [projectPage?.name] : []}
                        options={Object.values(FindProjectAPI.projectPages).map(p => p.name)}
                        onChange={(e, data) => redirectPage(Object.values(FindProjectAPI.projectPages).find(d => d.name === data?.[0])?.to)}
                    />}
                    {
                        projectPage && <>
                            <h3>{projectPage?.name} Categories</h3>
                            <CustomRadioInput value={subType ? [subType] : []}
                                options={projectPage.types}
                                onChange={(e, data) => redirectPage(projectPage.to + "/" + data?.[0])}
                            />
                        </>
                    }
                    {/* <h3>Applied Filters</h3>
                        {
                            toList(Object.keys(filters).flatMap(k => filters[k]), undefined, (item , i) => <CustomButton name={item} icon={<DeleteOutlined />} /> )
                        } */}
                    <CustomPagination page={page} pages={10} onChange={setCurrentPage}></CustomPagination>
                </div>
                <HireTalent title='' subTitle='' showMore={false} centerMode={false} talents={projects} perRow={3}></HireTalent>
                <div className='search-results-wrp'><CustomPagination page={page} pages={10} onChange={setCurrentPage}></CustomPagination></div>
            </div>
        </div>
        <Categories></Categories>
        <Footer></Footer>
    </div>);
}

export default FindProjectsPage;